import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { inject, ref, onMounted, watch } from "vue";
import { memberService, languageService, gaService } from "@/utils";
import { languageEnum } from "@/enums/plugins/i18n";
import { useRoute } from 'vue-router';
import { useTopNavBanner } from "@/composables/useTopNavBanner";
global.$ = $;
export default {
  name: "Topnav",
  setup() {
    const route = useRoute();
    const {
      sidebar,
      member
    } = inject("store");
    const {
      getRLloginUrl,
      getRLsignupUrl,
      logout
    } = memberService;
    const {
      getLanguagePath,
      getTargetLanguagePath
    } = languageService;
    const {
      gaTrackButtonClick,
      gaTrackEvent
    } = gaService;
    const {
      campaignBanner,
      getEventLabel
    } = useTopNavBanner();
    const elMenu = ref();
    const multiLangSwitcher = ref();
    const memberMenu = ref();
    const loggedInMemberMenu = ref();
    const hasTouchScreen = ref(false);
    const loginUrl = ref(getRLloginUrl());
    const signupUrl = ref(getRLsignupUrl());
    const submenuSettings = {
      refs: [multiLangSwitcher, memberMenu, loggedInMemberMenu],
      ListenEventTypes: ['touchstart', 'scroll', 'touchmove']
    };
    const clickSwitchButton = () => {
      const currentStatus = sidebar.states.isSidebarClose;
      sidebar.mutations.switchUserClose(currentStatus);
      sidebar.mutations.switchSidebarClose(currentStatus);
      gaTrackButtonClick("top-nav-hamburger");
    };
    const closeSubMenu = e => {
      if (e.target.className && e.target.className.includes('el-menu-item')) {
        $(e.target).trigger('click'); // mobile touch event 會點不到 el-menu-item 故觸發 click
      } else {
        submenuSettings.refs.forEach(el => {
          if (el.value?.index) {
            elMenu.value?.close(el.value?.index);
          }
        });
        submenuSettings.ListenEventTypes.forEach(eventType => window.removeEventListener(eventType, closeSubMenu, false));
      }
    };
    const handleSubMenuTouch = e => {
      e.stopPropagation();
      submenuSettings.ListenEventTypes.forEach(eventType => window.addEventListener(eventType, closeSubMenu, false));
    };
    onMounted(() => {
      submenuSettings.refs.forEach(el => {
        watch(el, () => el.value?.$el.addEventListener("touchstart", handleSubMenuTouch, false), {
          immediate: true
        });
      });

      // detect mobile device 
      if ("maxTouchPoints" in navigator) {
        hasTouchScreen.value = navigator.maxTouchPoints > 0;
      } else if ("msMaxTouchPoints" in navigator) {
        hasTouchScreen.value = navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia("(pointer:coarse)");
        if (mQ && mQ.media === "(pointer:coarse)") {
          hasTouchScreen.value = !!mQ.matches;
        } else if ('orientation' in window) {
          hasTouchScreen.value = true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          const UA = navigator.userAgent;
          hasTouchScreen.value = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
      }
    });
    watch(() => route.fullPath, () => {
      loginUrl.value = getRLloginUrl();
      signupUrl.value = getRLsignupUrl();
    });
    return {
      member,
      elMenu,
      multiLangSwitcher,
      memberMenu,
      loggedInMemberMenu,
      hasTouchScreen,
      loginUrl,
      signupUrl,
      logout,
      getLanguagePath,
      getTargetLanguagePath,
      languageEnum,
      clickSwitchButton,
      gaTrackButtonClick,
      gaTrackEvent,
      getEventLabel,
      campaignBanner
    };
  }
};